import HTTP from "../../http";

const USERS_ENDPOINT = "/users";
const REGISTER_ENDPOINT = "/register";

export async function register(user, verify_route) {
  return await HTTP.post(
    USERS_ENDPOINT + REGISTER_ENDPOINT,
    { user, verify_route },
    {
      headers: { "Content-Type": "application/json" }
    }
  );
}
